'use client'

import SvgIcon from '@mui/material/SvgIcon'
import PropTypes from 'prop-types'

export const LargeBillingAddressIcon = ({ sx }) => {
  return (
    <SvgIcon sx={sx} data-testid="LargeBillingAddressIcon">
      <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M8.57139 7.14307C6.06659 7.14307 4.28568 9.3493 4.28568 11.7462V28.2542C4.28568 30.6511 6.06659 32.8574 8.57139 32.8574H35.7142C38.2191 32.8574 40 30.6511 40 28.2542V11.7462C40 9.3493 38.2191 7.14307 35.7142 7.14307H8.57139Z"
          fill="#D8DCE5"
        />
        <path
          fillRule="evenodd"
          clipRule="evenodd"
          d="M2.14286 7.14307C0.959388 7.14307 0 8.10247 0 9.28592C0 10.4694 0.959388 11.4288 2.14286 11.4288H12.8571C14.0406 11.4288 15 10.4694 15 9.28592C15 8.10247 14.0406 7.14307 12.8571 7.14307H2.14286ZM2.14286 13.9288C0.959388 13.9288 0 14.8882 0 16.0716C0 17.2551 0.959388 18.2145 2.14286 18.2145H10C11.1835 18.2145 12.1429 17.2551 12.1429 16.0716C12.1429 14.8882 11.1835 13.9288 10 13.9288H2.14286ZM0 22.8574C0 21.6739 0.959388 20.7145 2.14286 20.7145H7.14286C8.32631 20.7145 9.28571 21.6739 9.28571 22.8574C9.28571 24.0408 8.32631 25.0002 7.14286 25.0002H2.14286C0.959388 25.0002 0 24.0408 0 22.8574ZM17.8571 20.0002C17.8571 17.2388 20.0957 15.0002 22.8571 15.0002C25.6186 15.0002 27.8571 17.2388 27.8571 20.0002C27.8571 22.7616 25.6186 25.0002 22.8571 25.0002C20.0957 25.0002 17.8571 22.7616 17.8571 20.0002Z"
          fill="#3D517B"
        />
      </svg>
    </SvgIcon>
  )
}

LargeBillingAddressIcon.propTypes = {
  sx: PropTypes.object
}
